import Flickity from 'flickity';

import {CustomScrollbar} from './custom-scrollbar';
import {Siblings} from './siblings';

const selectors = {
  slider: '[data-slider]',
  photo: '[data-grid-slide]',
  wrapper: '[data-wrapper]',
  carouselCustomScrollbar: 'data-custom-scrollbar-items',
};

const attributes = {
  showDots: 'data-show-dots',
};

const classes = {
  wrapper: 'wrapper',
  wrapperModifier: 'wrapper--full',
  hide: 'hide',
};

const offsets = {
  scrollbarWidth: window.innerWidth - document.documentElement.clientWidth,
  additionalOffsetWrapper: 112,
};

const sections = {};

class Slider {
  constructor(container, el) {
    this.container = container;
    this.slideshow = el;

    this.wrapper = this.container.querySelector(selectors.wrapper);
    this.wrapperWidth = Number(getComputedStyle(document.documentElement).getPropertyValue('--LAYOUT-WIDTH').replace('px', ''));
    this.wrapperWidthWithGutter = this.wrapperWidth + offsets.additionalOffsetWrapper + offsets.scrollbarWidth;

    this.pageDots = this.slideshow.getAttribute(attributes.showDots) === 'true';
    this.firstPhoto = this.container.querySelector(selectors.photo);

    if (this.firstPhoto) {
      const buttonOffset = this.firstPhoto.offsetHeight / 2;
      this.slideshow.style.setProperty('--buttons-top', `${buttonOffset}px`);
    }

    if (!this.slideshow) return;

    this.flkty = null;

    this.init();
  }

  init() {
    const instance = this;
    const sliderOptions = {
      initialIndex: 0,
      accessibility: true,
      autoPlay: false,
      contain: true,
      pageDots: this.pageDots,
      adaptiveHeight: false,
      wrapAround: false,
      groupCells: false,
      cellAlign: 'left',
      freeScroll: true,
      prevNextButtons: true,
      draggable: true,
      rightToLeft: window.isRTL,
      watchCSS: true,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 67.5,
        y2: 42.5,
        x3: 25,
      },
      on: {
        ready: function () {
          instance.removeIncorrectAria();
        },
      },
    };
    this.flkty = new Flickity(this.slideshow, sliderOptions);

    this.container.addEventListener('theme:tab:change', () => {
      this.flkty.resize();
    });

    this.toggleWrapperModifier();
    document.addEventListener('theme:resize:width', this.toggleWrapperModifier.bind(this));

    if (this.slideshow.hasAttribute(selectors.carouselCustomScrollbar)) {
      new CustomScrollbar(this.container);
    }

    new Siblings(this.container);
  }

  toggleWrapperModifier() {
    if (!this.wrapper.classList.contains(classes.wrapper)) {
      return;
    }

    this.wrapper.classList.toggle(classes.wrapperModifier, this.wrapperWidthWithGutter >= window.innerWidth);
  }

  removeIncorrectAria() {
    const slidesHidden = this.slideshow.querySelectorAll('[aria-hidden="true"]');
    slidesHidden.forEach((el) => el.removeAttribute('aria-hidden'));
  }

  onUnload() {
    if (this.slideshow && this.flkty) {
      this.flkty.options.watchCSS = false;
      this.flkty.destroy();
    }
  }
}

const productSliderSection = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.slider);
    els.forEach((el) => {
      sections[this.id].push(new Slider(this.container, el));
    });
  },
  onUnload(e) {
    sections[this.id].forEach((el) => {
      if (typeof el.onUnload === 'function') {
        el.onUnload(e);
      }
    });
  },
};

export {productSliderSection, Slider};
